module.exports = __webpack_public_path__ + "components/country-flag/static/tg-780d4b44f78db3a7ddb5d93c5302d64d.svg";